import { render } from "./AddItems.vue?vue&type=template&id=6b83e648&scoped=true"
import script from "./AddItems.vue?vue&type=script&lang=js"
export * from "./AddItems.vue?vue&type=script&lang=js"

import "./AddItems.vue?vue&type=style&index=0&id=6b83e648&lang=scss"
import "./AddItems.vue?vue&type=style&index=1&id=6b83e648&lang=scss&scoped=true"

import exportComponent from "/app/tmp/360pt/V3/v2026.6.r0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b83e648"]])

export default __exports__